module.exports = __webpack_public_path__ + "img/jo1.534c8411.png";